import React from 'react';
import SEO from '../components/SEO';
import './LegalPages.css';

const TermsAndConditions = () => {
  return (
    <>
      <SEO
        title="Terms and Conditions | Tech Update"
        description="Read Tech Update's Terms and Conditions. Learn about our service terms, payment policies, intellectual property rights, and refund policies."
        keywords="terms and conditions, service terms, payment terms, refund policy, legal terms"
        url="https://www.gettechupdate.com/terms-of-service"
      />
      <div className="legal-page">
      <div className="legal-container">
        <h1>Terms and Conditions</h1>
        <p className="last-updated">Last Updated: {new Date().toLocaleDateString()}</p>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using Tech Update's services, you accept and agree to be bound by the terms and provision of this agreement. 
            If you do not agree to abide by the above, please do not use this service.
          </p>
        </section>

        <section>
          <h2>2. Services</h2>
          <p>
            Tech Update provides web and mobile development services, including but not limited to:
          </p>
          <ul>
            <li>Android Application Development</li>
            <li>Web Development</li>
            <li>WordPress Development</li>
            <li>UI/UX Design Services</li>
          </ul>
          <p>
            We reserve the right to modify, suspend, or discontinue any service at any time without prior notice.
          </p>
        </section>

        <section>
          <h2>3. Client Responsibilities</h2>
          <p>Clients are responsible for:</p>
          <ul>
            <li>Providing accurate and complete information required for project completion</li>
            <li>Timely payment of agreed-upon fees</li>
            <li>Reviewing and approving project milestones in a timely manner</li>
            <li>Ensuring they have the legal right to use any content, images, or materials provided</li>
          </ul>
        </section>

        <section>
          <h2>4. Payment Terms</h2>
          <p>
            Payment terms will be specified in individual project agreements. Generally:
          </p>
          <ul>
            <li>Projects require a deposit before work begins</li>
            <li>Final payment is due upon project completion and delivery</li>
            <li>Late payments may incur additional fees</li>
            <li>All prices are in the currency specified in the project agreement</li>
          </ul>
        </section>

        <section>
          <h2>5. Intellectual Property</h2>
          <p>
            Upon full payment, clients receive ownership of the final deliverables. Tech Update retains the right to:
          </p>
          <ul>
            <li>Use completed projects in our portfolio</li>
            <li>Reference the work in marketing materials</li>
            <li>Retain copies for our records</li>
          </ul>
        </section>

        <section>
          <h2>6. Refund Policy</h2>
          <p>
            Refund requests must be submitted within 7 days of project completion. Refunds are subject to:
          </p>
          <ul>
            <li>Work completed up to the refund request date</li>
            <li>Non-refundable deposit (if applicable)</li>
            <li>Administrative processing fees</li>
          </ul>
        </section>

        <section>
          <h2>7. Limitation of Liability</h2>
          <p>
            Tech Update shall not be liable for any indirect, incidental, special, or consequential damages arising 
            out of or in connection with our services. Our total liability shall not exceed the total amount paid by 
            the client for the specific project.
          </p>
        </section>

        <section>
          <h2>8. Confidentiality</h2>
          <p>
            We respect client confidentiality and will not disclose proprietary information to third parties without 
            explicit consent, except as required by law.
          </p>
        </section>

        <section>
          <h2>9. Modifications to Terms</h2>
          <p>
            Tech Update reserves the right to modify these terms at any time. Continued use of our services after 
            changes constitutes acceptance of the new terms.
          </p>
        </section>

        <section>
          <h2>10. Contact Information</h2>
          <p>
            For questions about these Terms and Conditions, please contact us at:
          </p>
          <p>
            <strong>Email:</strong> info@gettechupdate.com<br />
            <strong>Phone:</strong> +91 8269277543
          </p>
        </section>
      </div>
    </div>
    </>
  );
};

export default TermsAndConditions;

